import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CustomerService } from '../proxy/controlling/controllers/customer.service';

FieldBuilder.setNamespace('Controlling');

export const CUSTOMERDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('country', 'Entity.CustomerDetail.Country')
    .required()
    .minLength(1)
    .maxLength(3)
    .build(),
  FieldBuilder
    .text('state', 'Entity.CustomerDetail.State')
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder
    .text('city', 'Entity.CustomerDetail.City')
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('street', 'Entity.CustomerDetail.Street')
    .minLength(1)
    .maxLength(255)
    .build(),
  FieldBuilder
    .text('postCode', 'Entity.CustomerDetail.PostCode')
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('telephoneNumber', 'Entity.CustomerDetail.TelephoneNumber')
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('cellphoneNumber', 'Entity.CustomerDetail.CellphoneNumber')
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('faxNumber', 'Entity.CustomerDetail.FaxNumber')
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('email', 'Entity.CustomerDetail.Email')
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('houseNumber', 'Entity.CustomerDetail.HouseNumber')
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('boxPostCode', 'Entity.CustomerDetail.BoxPostCode')
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .foreignKey('customerId', 'Entity.Customer', CustomerService)
    .required()
    .displayFromNested('customer.name')
    .sortBy('customer.name')
    .build(),
];

export const CUSTOMERDETAIL_CONFIG = {
  entityName: 'CustomerDetail',
  localizationKey: 'Controlling::Entity.CustomerDetail',
  fields: CUSTOMERDETAIL_FIELDS,
  permission: 'ControllingContract.CustomerDetails',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
